import { CircularProgress, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

export interface IServerDropdownOption<T extends string | number> {
    value: T;
    label: string;
}

interface IServerDropdownProps<T extends string | number> {
    value: T | null;
    onChange: (value: T | null) => void;
    options: IServerDropdownOption<T>[];
    loading?: boolean;
    label?: string;
    disabled?: boolean;
}

export function ServerDropdown<T extends string | number,>({
    value,
    onChange,
    options,
    loading = false,
    label,
    disabled,
}: IServerDropdownProps<T>) {
    function handleChange(event: SelectChangeEvent<T | ''>) {
        const val = event.target.value;
        onChange(val === '' ? null : val as T);
    }

    return (
        <FormControl fullWidth disabled={disabled || loading}>
            <InputLabel>{label}</InputLabel>
            <Select
                value={value ?? ''}
                label={label}
                onChange={handleChange}
                endAdornment={loading ? <CircularProgress size={16} sx={{ mr: 3 }} /> : null}
                MenuProps={{ style: { zIndex: 1000000 } }}
            >
                {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
